import { useState } from "react"
import If from "@mobi/components/If"
import Container from "../../components/Container"
import Title from "../../components/Title"
import Subtitle from "../../components/Subtitle"
import Image from "components/Image"
import Link from "../../components/Link"

import "./Partners.scss"
import classNames from "classnames"

const partners = [
  "magalu",
  "hipercard",
  "extra",
  "passai",
  "azul",
  "marisa",
  "muffato",
  "americanas",
  "latam",
  "walmart",
  "samsung",
  "compre-bem",
]

const Partners = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const onButtonClick = (event) => {
    event.preventDefault()
    setIsExpanded((state) => !state)
  }

  return (
    <section className="landing-partners">
      <Container>
        <Title>Cartões parceiros que você quita no Itaú</Title>

        <Subtitle>
          Agilidade para renegociar dívidas de vários cartões de crédito em um
          só lugar.
        </Subtitle>

        <div
          className={classNames("landing-partners__shelf", {
            "landing-partners__shelf--expanded": isExpanded,
          })}
        >
          {partners.map((partner) => {
            return (
              <div key={partner} className="landing-partners__shelf-item">
                <Image
                  src={`/images/landing/partners/${partner}.png`}
                  alt={partner.replace("-", " ")}
                />
              </div>
            )
          })}
        </div>

        <Link className="landing-partners__link" onClick={onButtonClick}>
          <If
            condition={isExpanded}
            renderIf="Mostrar menos cartões"
            renderElse="Mostrar todos os cartões"
          />
        </Link>
      </Container>
    </section>
  )
}

export default Partners
